<template>
	<div class="widget last-widget">
		<h6 class="uppercase margin-top-0 margin-bottom-40">{{ $t('Misc.SubscribeToOurNewsletter') }}</h6>

		<newsletter-subscription-form></newsletter-subscription-form>
	</div>
</template>

<script>
import NewsletterSubscriptionForm from '@/components/newsletters/NewsletterSubscriptionForm'

export default {
	name: 'FooterNewsletter',
	components: {
		NewsletterSubscriptionForm,
	},
}
</script>



// WEBPACK FOOTER //
// src/components/footer/FooterNewsletter.vue